export default function ErrorLabel({message}) {
    return (
        <p className="text-danger mt-2 error-label">{message}</p>
    )
}